import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationWrite } from '../../../../../../../openapi';
import { toNumber } from '../../../../../../../services/helpers';
import { bothRequired } from '../../../../../../../common/forms/custom.validators';

@Injectable()
export class DecisionOnDevelopmentConditionsInvestmentCharacteristicsForm extends AppForm {
  constructor() {
    super({
      investmentName: new FormControl(
        null,
        {
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      investmentAreaDesignation: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      investmentAreaSize: new FormControl('', { nonNullable: true, validators: [] }),

      existingDevelopment: new FormControl(
        null,
        {
          validators: [Validators.maxLength(5000)]
        }
      ),
      currentLandUse: new FormControl(
        null,
        {
          validators: [Validators.required, Validators.maxLength(5000)]
        }
      ),
      plannedLandUse: new FormControl(
        null,
        {
          validators: [Validators.required, Validators.maxLength(5000)]
        }
      ),

      buildingAreaExisting: new FormControl('', { nonNullable: true, validators: [] }),
      buildingAreaPlannedMin: new FormControl('', { nonNullable: true, validators: [] }),
      buildingAreaPlannedMax: new FormControl('', { nonNullable: true, validators: [] }),

      biologicalAreaExisting: new FormControl('', { nonNullable: true, validators: [] }),
      biologicalAreaPlannedMin: new FormControl('', { nonNullable: true, validators: [] }),
      biologicalAreaPlannedMax: new FormControl('', { nonNullable: true, validators: [] }),

      transformationAreaExisting: new FormControl('', { nonNullable: true, validators: [] }),
      transformationAreaPlannedMin: new FormControl('', { nonNullable: true, validators: [] }),
      transformationAreaPlannedMax: new FormControl('', { nonNullable: true, validators: [] }),

      impactDescription: new FormControl(
        null,
        {
          validators: [Validators.maxLength(5000)]
        }
      ),

      environmentalImpactData: new FormControl(
        null,
        {
          validators: [Validators.maxLength(5000)]
        }
      ),
      totalSalesOrUsableArea: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.maxLength(255)]
        }
      ),
      farmArea: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.maxLength(255)]
        }
      ),

      investmentAreaAdditionalInfo: new FormControl(
        null,
        {
          validators: [Validators.maxLength(5000)]
        }
      ),

      isSmallHouse70m2: new FormControl(false, { nonNullable: true }),
      isAgriculturalBiogas: new FormControl(false, { nonNullable: true }),
      isStrategicGridInvestment: new FormControl(false, { nonNullable: true }),
      isIndustrialHazardFacility: new FormControl(false, { nonNullable: true })
    }, {
      validators: [
        bothRequired(['buildingAreaExisting', 'buildingAreaPlannedMin', 'buildingAreaPlannedMax']),
        bothRequired(['biologicalAreaExisting', 'biologicalAreaPlannedMin', 'biologicalAreaPlannedMax']),
        bothRequired(['transformationAreaExisting', 'transformationAreaPlannedMin', 'transformationAreaPlannedMax'])
      ]
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      buildingAreaExisting: toNumber(this.value?.buildingAreaExisting),
      buildingAreaPlannedMin: toNumber(this.value?.buildingAreaPlannedMin),
      buildingAreaPlannedMax: toNumber(this.value?.buildingAreaPlannedMax),

      biologicalAreaExisting: toNumber(this.value?.biologicalAreaExisting),
      biologicalAreaPlannedMin: toNumber(this.value?.biologicalAreaPlannedMin),
      biologicalAreaPlannedMax: toNumber(this.value?.biologicalAreaPlannedMax),

      transformationAreaExisting: toNumber(this.value?.transformationAreaExisting),
      transformationAreaPlannedMin: toNumber(this.value?.transformationAreaPlannedMin),
      transformationAreaPlannedMax: toNumber(this.value?.transformationAreaPlannedMax),

      investmentAreaSize: toNumber(this.value.investmentAreaSize),

      totalSalesOrUsableArea: `${this.value.totalSalesOrUsableArea || ''}`,
      farmArea: toNumber(this.value.farmArea)
    };
  }
}
